import { useEffect } from 'react';

const SITE_URL = 'https://vengafarms.in';

const setMeta = (selector, attr, value) => {
  const tag = document.querySelector(selector);
  if (!tag || !value) return null;
  const previous = tag.getAttribute(attr);
  tag.setAttribute(attr, value);
  return () => tag.setAttribute(attr, previous);
};

export default function useSEO({ title, description, path = '/' }) {
  useEffect(() => {
    const previousTitle = document.title;
    if (title) document.title = title;

    const url = `${SITE_URL}${path}`;
    const restores = [
      setMeta('meta[name="description"]', 'content', description),
      setMeta('meta[property="og:title"]', 'content', title),
      setMeta('meta[property="og:description"]', 'content', description),
      setMeta('meta[property="og:url"]', 'content', url),
      setMeta('meta[name="twitter:title"]', 'content', title),
      setMeta('meta[name="twitter:description"]', 'content', description),
      setMeta('link[rel="canonical"]', 'href', url),
    ].filter(Boolean);

    return () => {
      document.title = previousTitle;
      restores.forEach((restore) => restore());
    };
  }, [title, description, path]);
}
